import { monitoring } from '@services/monitoring';

function handleRawApiError(func) {
  return async (...opts) => {
    try {
      const result = await func(...opts);
      return result;
    } catch (err) {
      const status = err?.response?.status;

      if (status !== 401 && status !== 403) {
        const requestUuid = err?.response?.headers?.['x-request-id'];

        monitoring.reportError(err, {
          ...(requestUuid && { requestId: requestUuid }),
          reportedFrom: 'raw-api-error',
        });
      }

      throw err;
    }
  };
}

export default handleRawApiError;
